import { graphql } from "@/gql";

export const ACKNOWLEDGE_CONTRACT = graphql(`
  mutation AcknowledgeContract($versionId: ID!, $data: JSON) {
    acknowledgeContract(versionId: $versionId, data: $data) {
      id
      pdfPublicId
      submittedData
      generatedAt
      sentToCustomerAt
      sentToKorbinianAt
      version {
        id
        version
      }
    }
  }
`);

export const CREATE_CONTRACT_TYPE = graphql(`
  mutation CreateContractType(
    $name: String!
    $description: String!
    $acknowledgementMode: String!
    $isBlocking: Boolean!
    $requiresReacknowledgement: Boolean!
  ) {
    createContractType(
      name: $name
      description: $description
      acknowledgementMode: $acknowledgementMode
      isBlocking: $isBlocking
      requiresReacknowledgement: $requiresReacknowledgement
    ) {
      id
      slug
      name
    }
  }
`);

export const UPDATE_CONTRACT_TYPE = graphql(`
  mutation UpdateContractType(
    $contractTypeId: ID!
    $name: String
    $description: String
    $isBlocking: Boolean
    $requiresReacknowledgement: Boolean
  ) {
    updateContractType(
      contractTypeId: $contractTypeId
      name: $name
      description: $description
      isBlocking: $isBlocking
      requiresReacknowledgement: $requiresReacknowledgement
    ) {
      id
      name
      description
      isBlocking
      requiresReacknowledgement
    }
  }
`);

export const DELETE_CONTRACT_TYPE = graphql(`
  mutation DeleteContractType($contractTypeId: ID!) {
    deleteContractType(contractTypeId: $contractTypeId)
  }
`);

export const UPLOAD_CONTRACT_VERSION = graphql(`
  mutation UploadContractVersion(
    $contractTypeId: ID!
    $content: String!
    $title: String!
  ) {
    uploadContractVersion(
      contractTypeId: $contractTypeId
      content: $content
      title: $title
    ) {
      id
      version
      title
      publishAt
    }
  }
`);

export const SCHEDULE_CONTRACT_VERSION = graphql(`
  mutation ScheduleContractVersion($versionId: ID!, $publishAt: DateTime) {
    scheduleContractVersion(versionId: $versionId, publishAt: $publishAt) {
      id
      version
      publishAt
      isPublished
      isScheduled
      isCurrent
    }
  }
`);

export const DELETE_CONTRACT_VERSION = graphql(`
  mutation DeleteContractVersion($versionId: ID!) {
    deleteContractVersion(versionId: $versionId)
  }
`);

export const CREATE_COUNTRY = graphql(`
  mutation CreateCountry(
    $name: String!
    $code: String!
    $order: Int!
    $isActive: Boolean!
  ) {
    createCountry(name: $name, code: $code, order: $order, isActive: $isActive) {
      id
      name
      code
      isActive
      order
    }
  }
`);

export const UPDATE_COUNTRY = graphql(`
  mutation UpdateCountry(
    $countryId: ID!
    $name: String
    $code: String
    $order: Int
    $isActive: Boolean
  ) {
    updateCountry(
      countryId: $countryId
      name: $name
      code: $code
      order: $order
      isActive: $isActive
    ) {
      id
      name
      code
      isActive
      order
    }
  }
`);

export const DELETE_COUNTRY = graphql(`
  mutation DeleteCountry($countryId: ID!) {
    deleteCountry(countryId: $countryId)
  }
`);

export const RESUBMIT_CONTRACT = graphql(`
  mutation ResubmitContract($contractTypeSlug: String!, $data: JSON) {
    resubmitContract(contractTypeSlug: $contractTypeSlug, data: $data) {
      id
      generatedAt
      version {
        id
        version
      }
    }
  }
`);
